import {
  useReducer,
  useMemo,
} from 'react';
import moment from 'moment';

const initialThemeState = {
  startDate: moment(),
  endDate: moment(),
  themeTitle: '',
  themeDescription: '',
  isLoading: false,
  isLoadingThemes: true,
  themes: [],
  showConfirmDeleteModal: false,
  themeToDeleteId: null,
  themeIdToEdit: null,
};

function checkInThemeReducer(state, action) {
  switch (action.type) {
    case 'SET_START_DATE':
      return { ...state, startDate: action.payload };

    case 'SET_END_DATE':
      return { ...state, endDate: action.payload };

    case 'SET_THEME_TITLE':
      return { ...state, themeTitle: action.payload };

    case 'SET_THEME_DESCRIPTION':
      return { ...state, themeDescription: action.payload };

    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_LOADING_THEMES':
      return { ...state, isLoadingThemes: action.payload };

    case 'SET_THEMES':
      return { ...state, themes: action.payload };

    case 'SET_CONFIRM_DELETE_MODAL':
      return { ...state, showConfirmDeleteModal: action.payload };

    case 'SET_THEME_TO_DELETE_ID':
      return { ...state, themeToDeleteId: action.payload };

    case 'SET_THEME_ID_TO_EDIT':
      return { ...state, themeIdToEdit: action.payload };

    case 'RESET_FORM':
      return {
        ...state,
        startDate: moment(),
        endDate: moment(),
        themeTitle: '',
        themeDescription: '',
        themeIdToEdit: null,
        isLoading: false,
      };

    default:
      return state;
  }
}

export const useCheckInTheme = () => {
  const [state, dispatch] = useReducer(checkInThemeReducer, initialThemeState);

  // Action Creators
  const actions = useMemo(() => (
    {
      setStartDate: (date) => dispatch({ type: 'SET_START_DATE', payload: date }),
      setEndDate: (date) => dispatch({ type: 'SET_END_DATE', payload: date }),
      setThemeTitle: (title) => dispatch({ type: 'SET_THEME_TITLE', payload: title }),
      setThemeDescription: (description) => dispatch({ type: 'SET_THEME_DESCRIPTION', payload: description }),
      setLoading: (loading) => dispatch({ type: 'SET_LOADING', payload: loading }),
      setLoadingThemes: (loading) => dispatch({ type: 'SET_LOADING_THEMES', payload: loading }),
      setThemes: (themes) => dispatch({ type: 'SET_THEMES', payload: themes }),
      setConfirmDeleteModal: (show) => dispatch({ type: 'SET_CONFIRM_DELETE_MODAL', payload: show }),
      setThemeToDeleteId: (id) => dispatch({ type: 'SET_THEME_TO_DELETE_ID', payload: id }),
      setThemeIdToEdit: (themeId) => dispatch({ type: 'SET_THEME_ID_TO_EDIT', payload: themeId }),
      resetForm: () => dispatch({ type: 'RESET_FORM' }),
    }
  ), []);

  const returnValue = useMemo(
    () => ({
      state,
      dispatch,
      actions,
    }),
    [state, dispatch, actions],
  );

  return returnValue;
};

export { initialThemeState };
